/**
 * Utilidades de texto para búsquedas y filtros.
 *
 * El objetivo principal es que las búsquedas sean insensibles tanto a
 * mayúsculas/minúsculas como a tildes/acentos. Así, buscar "apex" encuentra
 * "ápex" y viceversa.
 */

/**
 * Normaliza un texto para comparaciones: lo pasa a minúsculas, le quita los
 * acentos/diacríticos y recorta espacios en los extremos.
 *
 * Ejemplos:
 *   normalizeText('ÁPEX')   -> 'apex'
 *   normalizeText('Lobos')  -> 'lobos'
 *   normalizeText(null)     -> ''
 *
 * @param {unknown} value - Texto a normalizar (tolera null/undefined/números).
 * @returns {string} Texto normalizado, listo para comparar.
 */
export const normalizeText = (value) => {
  if (value == null) return '';
  return String(value)
    .normalize('NFD')
    // Elimina los diacríticos (acentos, diéresis, etc.) pero preserva la ñ,
    // que en NFD se descompone en 'n' + tilde combinante.
    .replace(/[\u0300-\u0302\u0304-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

/**
 * Indica si `needle` está contenido en `haystack`, ignorando mayúsculas y
 * tildes en ambos lados. Si `needle` está vacío, devuelve true (sin filtro).
 *
 * @param {unknown} haystack - Texto donde buscar (ej: nombre del equipo).
 * @param {unknown} needle - Texto buscado por el usuario.
 * @returns {boolean} true si hay coincidencia.
 */
export const textMatch = (haystack, needle) => {
  const n = normalizeText(needle);
  if (!n) return true;
  return normalizeText(haystack).includes(n);
};
